import { gql, MutationHookOptions, useMutation } from '@apollo/client'
import type {
  SubscribeToChangesMutation,
  SubscribeToChangesMutationVariables,
} from 'apollo-gql'
import { currentMarketIdVar } from 'graphql/reactive'

const mutation = gql`
  mutation SubscribeToChanges(
    $marketId: ID!
    $input: SubscribeToChangesInput!
  ) {
    market(id: $marketId) {
      subscribeToChanges(input: $input) {
        errors {
          identifier
          message
          field
        }
        result
      }
    }
  }
`

type MutationFunction = (
  input: SubscribeToChangesMutationVariables['input'],
) => Promise<void>

type UseSubscribeToChanges = (
  options?: MutationHookOptions<
    SubscribeToChangesMutation,
    SubscribeToChangesMutationVariables
  >,
) => [MutationFunction, { loading: boolean }]

const useSubscribeToChanges: UseSubscribeToChanges = ({
  onCompleted = () => undefined,
}) => {
  const marketId = currentMarketIdVar()

  const [mutate, { loading }] = useMutation(mutation, {
    onCompleted,
  })

  const subscribeToChanges: MutationFunction = async (input) => {
    if (!input) throw new Error('input is required')

    await mutate({
      variables: {
        marketId,
        input,
      },
    })
  }

  return [subscribeToChanges, { loading }]
}

export default useSubscribeToChanges
